import { useSelector } from 'react-redux';
import {
  isAdviserArea as selectIsAdviserArea,
  selectCurrentClient,
} from '../../../CommonSelectors/CommonAreaSelector';
import { isOptedIn } from '../../../CommonUtils/isOptedIn';
import { canShareConsumersSelector } from '../../../SharingSettings/SharingSettingsSelector';
import { canInviteConsumerSelector } from '../../../AdviserArea/AdviserAreaSelector';

export const useFooter = () => {
  const currentClient = useSelector(selectCurrentClient);

  const isAdvisorArea = useSelector(selectIsAdviserArea);

  const canShareClient = isAdvisorArea && useSelector(canShareConsumersSelector);

  const canInviteClient = isAdvisorArea && useSelector(canInviteConsumerSelector);

  const canDeleteClient =
    isOptedIn('DeleteClient') && (canShareClient || currentClient.CanDeleteConsumer);

  return {
    currentClient,
    canInviteClient,
    canDeleteClient,
  };
};
